import Section from 'react-scale/components/elements/section';
import Quote from 'react-scale/components/sections/quotes';
import SectionTitle from 'react-scale/components/elements/section-title';

const QuotesSection = ({ quotes = [] }) => {
  return (
    <Section>
      <SectionTitle
        overtitleClassName="text-gradient-pink"
        overtitle="Customers"
        title="We have changed the game of AI data—hear it from our customers."
        subtitle="From RLHF to data labeling to model evaluation to enterprise apps, learn from experts why Scale is key to any AI strategy."
        link={undefined}
        product={undefined}
        cta={undefined}
      />
      <Quote quotes={quotes} image={undefined} />
    </Section>
  );
};

export default QuotesSection;
